import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

interface Props {
  boxStyle?: 'raised' | 'border';
  padding?: string;
  size?: 'small' | 'medium';
}


export default /*#__PURE__*/_defineComponent({
  props: {
    boxStyle: { default: 'border' },
    padding: { default: undefined },
    size: { default: 'medium' }
  },
  setup(__props: any) {

const props = __props as { boxStyle: 'raised' | 'border', padding: string, size: 'small' | 'medium' }

const SMALL_PADDING = 'px-5 py-4';
const MEDIUM_PADDING = 'px-7 py-4';



const classes = computed(() => [
  {
    'shadow bg-white': props.boxStyle === 'raised',
    border: props.boxStyle === 'border',
  },
  props.size === 'small' || props.boxStyle === 'raised'
    ? 'rounded ' + (props.padding || SMALL_PADDING)
    : 'rounded-lg ' + (props.padding || MEDIUM_PADDING),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})